import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-cmd-icon',
  templateUrl: './code-cmd.component.html'
})
export class CodeCMDComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
